import type { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import RichTextDomain from '@src/quince-site-common/src/domains/RichText'
import RichTextSection from '@src/SectionRenderer/sections/richTextSection'

import { buildWidgetTrackingMetaData, protoButtonToDomain, toRichText } from '../widget-utils'

import type { RichTextWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

function buildSectionConfig(widgetId: string, data: RichTextWidgetData): CustomSection {
  const richTexts = data.richTexts.map(rt => toRichText(rt)).filter((rt): rt is RichTextDomain => rt !== undefined)

  const trackingMetaData = buildWidgetTrackingMetaData(data.analytics)

  return new CustomSection({
    id: widgetId,
    title: data.title,
    sectionType: (data.sectionType ?? '') as CustomSection['sectionType'],
    richTexts,
    buttons: data.buttons.map(b => protoButtonToDomain(b as Record<string, unknown>)) as CustomSection['buttons'],
    classNames: data.classNames,
    baseDynamicClasses: data.baseDynamicClasses,
    mobileDynamicClassesOverrides: data.mobileDynamicClassesOverrides,
    classNamesMobileOverrides: [],
    influencers: [],
    layoutType: LAYOUT_TYPES.DEFAULT,
    trackingMetaData,
  })
}

/** Legacy (non-DS) branch of the PL `RICH_TEXT` widget. Delegates to RichTextSection + SCSS. */
export function RichTextWidgetLegacy(props: PLTypedWidgetProps<RichTextWidgetData>) {
  const data = (props.data as { richTextData?: RichTextWidgetData }).richTextData
  if (!data) return null

  return <RichTextSection sectionConfig={buildSectionConfig(props.id || '', data)} />
}
